module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAaklEQVQ4y2NgGBTg4rVb/8nBtDVg/dZd/wurm8G4fcL0/8dOXyDNgMqmrv9zFq/8f+DYabAhi1auJ96AMxevwm1csX4r2ACQi0gOA5g3QIaQFYi7DhzF6nT6xAIIgwIR5IWBcwHRBgxtAABNpA3QUIylAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_unknown.png
// module id = 1325
// module chunks = 0